import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export class accountDeletedView extends Vue {


}


